import { Col, Row } from "react-bootstrap";

function Header() {
  const publicBasePath =
    process.env.PUBLIC_URL && process.env.PUBLIC_URL !== "."
      ? process.env.PUBLIC_URL
      : "";
  const logoSrc = `${publicBasePath}/images/OTS2026_logo-digital-white-y.png`;

  return (
    <Row id="header">
      <Col md={5} className="mb-3 mt-5 ps-4 pe-4 ps-md-2 pe-md-2 mb-md-5 mt-md-5">
        <a href="https://www.ots.si/">
          <img src={logoSrc} alt="OTS 2026 logo" />
        </a>
      </Col>
      <Col
        md={7}
        className="mb-5 mt-3 ps-4 pe-4 ps-md-2 pe-md-2 mb-md-5 mt-md-5 d-flex align-items-center justify-content-start justify-content-md-end"
      >
        <div className="date">
          2. in 3. september 2026 <br /> MARIBOR
        </div>
      </Col>
    </Row>
  );
}

export default Header;
